module.exports = __webpack_public_path__ + "img/ki.28e34a88.svg";